import React from "react";
import { useTranslation } from "react-i18next";
import { useLiveStream } from "../../contexts/YouTubeContext";

const LiveStreamBanner = () => {
  const { t } = useTranslation();
  const { liveVideo } = useLiveStream();

  if (!liveVideo) return null;

  const videoUrl = `https://www.youtube.com/watch?v=${liveVideo.videoId}`;

  return (
    <div className="fixed top-28 right-6 z-50">
      <a
        href={videoUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="relative flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white font-poppins font-bold text-[13px] px-4 py-2 rounded-full shadow-lg transition-colors"
      >
        <span className="relative flex h-3 w-3 shrink-0">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75" />
          <span className="relative inline-flex rounded-full h-3 w-3 bg-white" />
        </span>
        {t("liveNow")}
      </a>
    </div>
  );
};

export default LiveStreamBanner;
